<div class="mx-auto flex h-full w-full max-w-[1600px] flex-col gap-6 px-8 py-6 min-h-0">

  <!-- Read-only banner — renders nothing when user has write access -->
  <cmt-brand-readonly-banner />

  <!-- Hero card -->
  <section class="rounded-2xl border border-border bg-card p-6 shadow-sm">
    <div class="flex flex-wrap items-start justify-between gap-4">
      <div class="flex min-w-0 flex-1 flex-col gap-1">
        <p class="cmt-eyebrow">Domains</p>
        <h1 class="font-display text-3xl font-semibold leading-tight text-foreground">
          Domains
        </h1>
        <p class="text-sm text-muted-foreground">
          Global domain registry — maps each domain to its default brand and sub-brand.
        </p>
      </div>

      <div class="flex flex-none items-center gap-2 pt-1">
        <button
          hlmBtn
          variant="default"
          (click)="openAdd()"
          [disabled]="!canWrite()"
          [attr.title]="!canWrite() ? 'Read-only access — needs amie.brandManager.write to enable' : null"
        >
          <hlm-icon name="lucidePlus" size="0.9rem" />
          Add domain
        </button>
      </div>
    </div>

    <!-- Search bar -->
    <div class="mt-5 flex flex-wrap items-center gap-4">
      <div class="relative max-w-md flex-1 min-w-[240px]">
        <hlm-icon
          name="lucideSearch"
          size="1rem"
          class="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-muted-foreground"
        />
        <input
          hlmInput
          size="sm"
          class="pl-11 pr-10"
          placeholder="Search by domain or brand…"
          [value]="filterText()"
          (input)="filterText.set($any($event.target).value)"
        />
        @if (filterText()) {
          <button
            hlmBtn
            variant="ghost"
            size="icon"
            class="absolute right-1 top-1/2 h-11 w-11 md:h-7 md:w-7 -translate-y-1/2"
            type="button"
            tabindex="-1"
            (click)="filterText.set('')"
            aria-label="Clear search"
          >
            <hlm-icon name="lucideX" size="0.8rem" />
          </button>
        }
      </div>

      <div class="inline-flex items-center gap-2 rounded-full border border-border bg-muted/50 px-3 py-1.5 font-mono-feat text-xs uppercase tracking-[0.1em] text-muted-foreground">
        <span class="text-foreground">{{ rows().length }}</span>
        <span>{{ rows().length === 1 ? 'domain' : 'domains' }}</span>
      </div>
    </div>
  </section>

  <!-- Grid / loading / empty -->
  @if (loading()) {
    <div class="flex items-center gap-3 p-6 text-sm text-muted-foreground">
      <hlm-spinner size="20" /> Loading domains…
    </div>
  } @else if (rows().length === 0 && !filterText()) {
    <div class="rounded-2xl border border-dashed border-border bg-card/50 p-12 text-center text-sm text-muted-foreground">
      No domains registered yet. Click <span class="font-medium text-foreground">Add domain</span> to create one.
    </div>
  } @else if (rows().length === 0) {
    <div class="rounded-2xl border border-dashed border-border bg-card/50 p-12 text-center text-sm text-muted-foreground">
      No domains match "<span class="font-mono-feat">{{ filterText() }}</span>".
    </div>
  } @else {
    <!-- Definite-height wrapper so AG-Grid uses normal layout: it scrolls
         internally and pins the column header (native behaviour). -->
    <div class="h-[calc(100vh-15rem)] min-h-[18rem]">
      <ag-grid-angular
        class="ag-theme-material cmt-grid h-full"
        [rowData]="rows()"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [context]="gridContext"
        [pagination]="true"
        [paginationPageSize]="50"
        [suppressHorizontalScroll]="true"
        (gridReady)="onGridReady($event)"
        (firstDataRendered)="onFirstDataRendered($event)"
        (gridSizeChanged)="onGridSizeChanged($event)"
        (rowClicked)="onRowClicked($event)"
      />
    </div>
  }
</div>
